import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from '../../components/emtLevel';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>1.0 Routine Patient Care</li>
    <li>
      Provide rapid cooling as soon as possible.
    </li>
    <li>
      <strong>CAUTION:</strong> Do not over-chill patient, observe for shivering. If shivering occurs,
      discontinue active cooling procedures.
    </li>
    <li>Move patient to cool area.</li>
    <li>Loosen or remove all unnecessary clothing, while protecting privacy.</li>
    <li>Apply cool packs to armpits, neck and groin.</li>
    <li>Use evaporation techniques if possible (fans, open windows).</li>
    <li>Keep skin wet by applying water with wet towels or sponges.</li>
    <li>
      For Heat Cramps and/or Heat Exhaustion: administer water or oral re-hydrationelectrolyte
      solution if patient is alert and has a normal gag reflex and can
      swallow easily. Elevate legs of supine patient with heat exhaustion.
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <ul>
    <li>Consider 500mL fluid bolus for dehydration even if vital signs are normal.</li>
    <li><strong>Pediatrics:</strong> 20mL/kg bolus, if indicated.</li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>Follow above protocols</li>
  </ul>
    </EMTLevel>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      